import { SearchOutlined, PlusCircleOutlined, CloseCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, HddOutlined, EditOutlined, FileExcelOutlined, DeleteOutlined, FileImageOutlined } from '@ant-design/icons';
import { Col, DatePicker, TimePicker, Form, InputRef, List, Row, Tooltip as tp } from 'antd';
import { Button, Input, Space, Table, Modal, InputNumber, Select, Drawer } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';
import React, { useRef, useState, useEffect } from 'react';
import className from '../Tables.module.scss'
import styles from './GeiEvent.module.scss';
import {
  postRegisterGeiEvent, putRegisterGeiEvent, putActivoGeiEvent, putRegisterStatusGeiEvent, getGeiEventById, getGeiEventScheduleByEventId,
  getGeiEventActivityByScheduleId, postGeiEventActivity, getGeiEventResults, deleteGeiEventActivityById, getEmissionsByTypeId, putScheduleGeiEvent, putGeiActivityEvent
} from '../../../../store/geiEvent/thunks';
import { connect } from 'react-redux';
import { AppState } from '../../../../store';
import moment from 'moment';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateIdentification, validateLetters, validatePhoneEC, validateBirthday, validateNumber, validateYear4, validate100, validateHourFormat } from '../../../../globals/Inputs/validateInput';
import validateMessages from '../../../../globals/Inputs/validateMessages';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { Cities, Organization } from '../../../../store/organization/types';
import { openNotification } from '../../../../globals/Components/Notification/Notificaction';
import TextArea from 'antd/es/input/TextArea';
import { getAllOrganization, getAllCitiesByOrganization, getOrganizationById, getLinkByorganizationIdAndService } from '../../../../store/organization/thunks';
import { getTypeEvent } from '../../../../store/emissions/thunks';
import { GeiEventsRegister, GeiEventsUpdate, GeiEvents, GeiEventStatus, GeiTypeEvents, GeiEventsSchedule, GeiEventsActivity, GeiEventsActivityRegister, GeiEventResults, GeiEventsResponse } from '../../../../store/geiEvent/types';
import { UserState } from '../../../../store/user/types';
import { TablePaginationConfig } from 'antd/lib/table/interface';
import { getUserByToken } from '../../../../store/user/thunks';
import { useHistory, useParams } from 'react-router-dom';
import { EmissionsSource } from "src/store/emissions/types";
import { getTransformationFactorsUnitByEmissionorganizationId, getTransformationFactorsUnitByEmissionId, getTransformationFactorsUnitByEmissionSourceId } from "src/store/transformationfactors/thunks";
import { getAllEmissionsTable, getEmissionsOrganization } from "src/store/emissions/thunks";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, } from "chart.js";
import dayjs from 'dayjs';
import LoadingIndicator from 'src/globals/Components/Loading/LoadingIndicator';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import PowerBI from '../PowerBI/PowerBI';


ChartJS.register(ArcElement, Tooltip, Legend);
interface UserTableProps {
  postRegisterGeiEvent?: any;
  putRegisterGeiEvent?: any;
  putActivoGeiEvent?: any;
  putRegisterStatusGeiEvent?: any;
  getGeiEventById?: any;
  getUserByToken?: any;
  getAllCitiesByOrganization?: any;
  getAllOrganization?: any;
  getTypeEvent?: any;
  getGeiEventScheduleByEventId?: any;
  getGeiEventActivityByScheduleId?: any;
  getTransformationFactorsUnitByEmissionorganizationId?: any;
  getTransformationFactorsUnitByEmissionId?: any;
  getTransformationFactorsUnitByEmissionSourceId?: any;
  getEmissionsOrganization?: any;
  postGeiEventActivity?: any;
  getGeiEventResults?: any;
  deleteGeiEventActivityById?: any;
  getEmissionsByTypeId?: any;
  putScheduleGeiEvent?: any;
  putGeiActivityEvent?: any;
  user: UserState;
  getLinkByorganizationIdAndService?: any;
}

/*export interface DataEvents {
  key: number | null;
  id: string | null;
  name: string | null;
  theme: string | null;
  duration: number | null;
  participant: number | null;
  observation: string | null;
  msCatalogueCityId: string | null;
  msCatalogueCityName: string | null;
  address: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  msIdentityOrganizationId: string | null;
  msIdentityOrganizationRuc: string | null;
  msIdentityTypeEventId: string | null;
  msIdentityTypeEventName: string | null;
  status: string | null;
}*/

type DataIndexEvent = keyof GeiEvents;
type DataIndexActivity = keyof GeiEventsActivity;
type RequiredMark = boolean | 'optional';
const TGeiEvents: React.FC<UserTableProps> = (props: UserTableProps) => {
  interface RouteParams {
    idOrganization: string;
  }
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDays, setSelectedDays] = useState<string[]>([]);
  const [isSelecting, setIsSelecting] = useState(false);
  const [startDay, setStartDay] = useState<number | null>(null);
  const today = new Date();
  const [pagesize, setPageSize] = useState(5);
  const [dataEvents, setDataEvents] = useState<GeiEvents[]>([]);
  const [dataEventsSchedule, setDataEventsSchedule] = useState<GeiEventsSchedule[]>([]);
  const [selectedEventsSchedule, setSelectedEventsSchedule] = useState<GeiEventsSchedule | null>(null);//AQUI
  const [dataEventsActivity, setDataEventsActivity] = useState<GeiEventsActivity[]>([]);
  const [selectedEventActivity, setSelectedEventActivity] = useState<GeiEventsActivity | null>(null);
  const [dataEventsResults, setDataEventsResult] = useState<GeiEventResults | null>(null);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef<InputRef>(null);
  const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
  const dateFormat = 'DD-MM-YYYY';
  const [formEvents] = Form.useForm();
  const [formActivityEvent] = Form.useForm();
  const [formValidateEvent] = Form.useForm();
  const [formValidateActivity] = Form.useForm();
  const [formSchedule] = Form.useForm();
  const [formValidateSchedule] = Form.useForm();
  const [formInactiveEvent] = Form.useForm();
  const [formValidateInactiveEvent] = Form.useForm();
  const [isModalOpenEvent, setIsModalOpenEvent] = useState(false);
  const [isModalOpenActivity, setIsModalOpenActivity] = useState(false);
  const [isModalOpenSchedule, setIsModalOpenSchedule] = useState(false);
  const [isModalOpenInactiveEvent, setIsModalOpenInactiveEvent] = useState(false);
  const [typeModalEvent, setTypeModalEvent] = useState(true);
  const [typeModalActivity, setTypeModalActivity] = useState(true);
  const [typeModalInactiveEvent, setTypeModalInactiveEvent] = useState(true);
  const [geiId, setGeiId] = useState(String);
  const [scheduleId, setScheduleId] = useState(String);
  const [selectGeiEvent, setSelectGeiEvent] = useState<GeiEvents>();
  const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
  const params = useParams<RouteParams>();
  const { Option } = Select;
  const [type, setType] = useState("");
  const [cities, setCities] = useState([]);
  const [previousSelectedDays, setPreviousSelectedDays] = useState<string[]>([]);
  const [sortedDays, setSortedDays] = useState<string[]>([]);
  const [typeOrganization, setTypeOrganization] = useState("");
  const [organization, setOrganization] = useState([]);
  const [typeEvent, setTypeEvent] = useState("");
  const [typeEvents, setEvents] = useState([]);
  const [selectedScheduleId, setSelectedScheduleId] = useState<string | undefined>(undefined);
  const [selectedScheduleDate, setSelectedScheduleDate] = useState<string | undefined>(undefined);
  const [selectDataTableEmissions, setSelectDataTableEmissions] = useState<EmissionsSource[]>([]);
  const [searchValue, setSearchValue] = useState<EmissionsSource>();
  const [dataBaseUnit, setDataBaseUnit] = useState([]);
  const [typeActivity, setTypeActivity] = useState("");
  const [chartData, setChartData] = useState<{ labels: string[]; values: number[] }>({ labels: [], values: [] });
  const [chartColors, setChartColors] = useState<string[]>([]);
  const timeFormat = 'HH:mm';
  const history = useHistory();
  const [isShowButtomLink, setIsShowButtomLink] = useState(false);
  const [isUrlLinkButtom, setIsUrlLinkButtom] = useState("");
  //const isChubb = props.user.organizationid === 'ee847bf4-881b-402d-9846-9cb0b72f959c';
  const isChubb = true;
  const predefinedColors = [
    "#9E9BE7", // morado fuccia
    "#6D7ECF", // morado chicle
    "#66B285", // verde chicle
    "#A9ADA6", //gris
    "#674C80", //morado pastel
    "#A9AE91", //Pastel crema
    "#AFCD92", //verde Limon
    "#C2C39D",//Pastel claro
    "#85A84F", // verde pastel
    "#4A9BA2", //celeste pastel
  ];

  const chubbColors = [
    "#FF6600", // NARANAJA
    "#6E27C5", // MORADO
    "#150F96", // AZUL
    "#FFB617", // AMARILLO
    "#01C1D6", // CELESTE
    "#7ACB00", // VERDE
    "#F1352B", // ROJO
    "#FF0198", // FUCCIA
    "#AFAFAF"  // GRIS
  ];

  const getColorsForLabels = (labels: string[]): string[] => {
    return labels.map((_, index) => props.user.organizationid !== 'ee847bf4-881b-402d-9846-9cb0b72f959c' ? chubbColors[index % chubbColors.length] : predefinedColors[index % predefinedColors.length]);
  };

  const generateChartData = (dataEventsResults: GeiEventResults) => {
    const labels = dataEventsResults.individualEventResultsResponses.map((event) => event.name);
    const values = dataEventsResults.individualEventResultsResponses.map((event) => event.totalEmissiontco2);
    const colors = getColorsForLabels(labels);

    return { labels, values, colors };
  };

  const DoughnutChart = React.memo(({ data }: { data: { labels: string[]; values: number[]; colors: string[] } }) => {
    const chartData = {
      labels: data.labels,
      datasets: [
        {
          data: data.values,
          backgroundColor: data.colors,
          borderWidth: 1,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
      },
    };

    return (
      <div style={{ width: "250%", height: "250px" }}>
        <Doughnut data={chartData} options={options} />
      </div>
    );
  });

  const EventList = React.memo(({ events, colors }: { events: any[]; colors: string[] }) => (
    <ul className={styles.listContainer}>
      {events.map((event, index) => (
        <li
          key={index}
          className={`${styles.listItem} ${index % 2 === 0 ? styles.listItemEven : styles.listItemOdd}`}
        >

          <div
            className={styles.numberContainer}
            style={{ backgroundColor: colors[index] }}
          >
            {index + 1}
          </div>

          <div>{event.name}</div>
          <div>{event.totalEmissiontco2.toFixed(3)} t-CO₂</div>
        </li>
      ))}
    </ul>
  ));

  useEffect(() => {
    if (dataEventsResults) {
      const chartData = generateChartData(dataEventsResults);
      setChartData({ labels: chartData.labels, values: chartData.values });
      setChartColors(chartData.colors);
    }
  }, [dataEventsResults]);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getResponsiveStyle = () => {
    if (screenSize <= 1400) {
      return 'small-screen';
    }
    return 'default-screen';
  };




  const generateRandomColors = (count: number): string[] => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(`#${Math.floor(Math.random() * 16777215).toString(16)}`);
    }
    return colors;
  };

  const extractChartData = (dataResults: GeiEventResults) => {
    const labels = dataResults.individualEventResultsResponses.map((event) => event.name);
    const values = dataResults.individualEventResultsResponses.map((event) => event.totalEmissiontco2);
    return { labels, values };
  };




  const formatSelectedDate = (schedule: GeiEventsSchedule): string => {
    const { year, month, day } = schedule.date;
    return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
  };


  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: pagesize,
  });
  const handleTableChange = async (pagination: TablePaginationConfig) => {

    setPagination({ ...pagination });
    const responseData: GeiEventsResponse = await props.getGeiEventById(pagination.current, pagination.pageSize, "");
    setDataEvents(responseData.eventsTables);
  };



  const init = async () => {
    const responseData: GeiEventsResponse = await props.getGeiEventById(pagination.current, pagination.pageSize, "");
    setPagination({
      current: 1,
      pageSize: pagesize,
      total: responseData.totalTable
    })
    setDataEvents(responseData.eventsTables);

    const responseDataOrganization = await props.getAllOrganization();
    setOrganization(responseDataOrganization);

    const responseDataTypeEvent = await props.getTypeEvent();
    setEvents(responseDataTypeEvent);
  }

  useEffect(() => {
    init();
  }, []);

  const handleSearch = async (
    selectedKeys: string[]
  ) => {
    if (props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190") {
      const responseData: GeiEventsResponse = await props.getGeiEventById(pagination.current, pagination.pageSize, selectedKeys.length > 0 ? selectedKeys[0] : "NULL");
      setDataEvents(responseData.eventsTables);
    } else if (props.user.rol == "83ce86cf-fe89-4eaf-9ea6-20efa405f690") {
      const responseData: GeiEventsResponse = await props.getGeiEventById(pagination.current, pagination.pageSize, selectedKeys.length > 0 ? selectedKeys[0] : "NULL");
      setDataEvents(responseData.eventsTables);
    }

  };

  const handleReset = async (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
    if (props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190") {
      const responseData: GeiEventsResponse = await props.getGeiEventById(pagination.current, pagination.pageSize, "");
      setDataEvents(responseData.eventsTables);
    } else if (props.user.rol == "83ce86cf-fe89-4eaf-9ea6-20efa405f690") {
      const responseData: GeiEventsResponse = await props.getGeiEventById(pagination.current, pagination.pageSize, "");
      setDataEvents(responseData.eventsTables);
    }
  };

  const getColumnSearchPropsEvents = (dataIndex: DataIndexEvent, title: string): ColumnType<GeiEvents> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Buscar ${title}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[])}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[])}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reiniciar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const fieldValue = record?.[dataIndex] ?? "";
      return fieldValue.toString().toLowerCase().includes((value as string).toLowerCase());
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columnOrganizationAdminType: ColumnType<GeiEvents> = {
    title: "Organización",
    dataIndex: "msIdentityOrganizationId",
    key: "msIdentityOrganizationId",
    width: 25,
    ...getColumnSearchPropsEvents("msIdentityOrganizationId", "Organización"),
  };
  const columnRUCAdminType: ColumnType<GeiEvents> = {
    title: "Organización",
    dataIndex: "msidentityOrganizationName",
    key: "msidentityOrganizationName",
    width: 20,
    onHeaderCell: () => ({
      className: styles.tableHeader,
    }),
    onCell: () => ({
      className: styles.tableContent,
    }),
  };

  const columnsTypeEvent: ColumnsType<GeiEvents> = [
    {
      title: "Evento",
      dataIndex: "name",
      key: "name",
      width: 15,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: (record) => ({
        className: styles.tableContent, style: { cursor: "pointer", color: "#1890ff" },
        onClick: async () => {
          try {
            setDataEventsSchedule([]);
            setDataEventsActivity([]);
            setSelectedScheduleId(undefined);
            setSelectedScheduleDate(undefined);

            const responseDataLink = await props.getLinkByorganizationIdAndService(record.msIdentityOrganizationId, "EVENTOS_GEI");
            if (responseDataLink != undefined) {
              setIsShowButtomLink(true);
              setIsUrlLinkButtom(responseDataLink.url);
            } else {
              setIsShowButtomLink(false);
              setIsUrlLinkButtom("");
            }

            const responseDataSchedules = await props.getGeiEventScheduleByEventId(record.id);
            setDataEventsSchedule(responseDataSchedules || []);

            const responseDataResults = await props.getGeiEventResults(record.id);

            if (JSON.stringify(dataEventsResults) !== JSON.stringify(responseDataResults)) {
              setDataEventsResult(responseDataResults);
            }

            if (responseDataSchedules.length > 0) {
              const firstSchedule = responseDataSchedules[0];
              setSelectedEventsSchedule(responseDataSchedules[0]);
              setSelectedScheduleId(firstSchedule.id);
              setSelectedScheduleDate(formatSelectedDate(firstSchedule));
              setSelectGeiEvent(record);

              const responseDataActivity = await props.getGeiEventActivityByScheduleId(firstSchedule.id);
              setDataEventsActivity(responseDataActivity || []);
            }
          } catch (error) {
            console.error("Error al obtener resultados del evento:", error);
          }
        },

      }),
      ...getColumnSearchPropsEvents("name", "Nombre del evento"),
    },
    {
      title: "Tipo",
      dataIndex: "msIdentityTypeEventName",
      key: "msIdentityTypeEventName",
      width: 12,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    {
      title: "Tema",
      dataIndex: "theme",
      key: "theme",
      width: 15,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
      ...getColumnSearchPropsEvents("theme", "Tema"),
    },
    {
      title: "Tiempo",
      dataIndex: "duration",
      key: "duration",
      width: 8,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
      ...getColumnSearchPropsEvents("duration", "Duración"),
    },
    {
      title: "Personas",
      dataIndex: "participant",
      key: "participant",
      width: 15,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    {
      title: "Ciudad",
      dataIndex: "msCatalogueCityName",
      key: "msCatalogueCityName",
      width: 12,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    {
      title: "Dirección",
      dataIndex: "address",
      key: "address",
      width: 30,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    /*{
      title: "Estado",
      dataIndex: "status",
      key: "status",
      width: 15,
      onHeaderCell: () => ({
      className: styles.tableHeader, // Aplica estilos al encabezado
    }),
    onCell: () => ({
      className: styles.tableContent, // Aplica estilos al contenido
    }),
      ...getColumnSearchProps("status", "Estado"),
    },
    {
      title: "Creado",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 20,
      onHeaderCell: () => ({
      className: styles.tableHeader, // Aplica estilos al encabezado
    }),
    onCell: () => ({
      className: styles.tableContent, // Aplica estilos al contenido
    }),
    },
    {
      title: "Última actualización",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 20,
      onHeaderCell: () => ({
      className: styles.tableHeader, // Aplica estilos al encabezado
    }),
    onCell: () => ({
      className: styles.tableContent, // Aplica estilos al contenido
    }),
    },*/
  ];
  const columnsTypeActivity: ColumnsType<GeiEventsActivity> = [
    {
      title: "Equipo",
      dataIndex: "emissionSourceName",
      key: "emissionSourceName",
      width: 5,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    {
      title: "Fuente",
      dataIndex: "sourceName",
      key: "sourceName",
      width: 5,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    {
      title: "Base",
      dataIndex: "baseUnit",
      key: "baseUnit",
      width: 5,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    {
      title: "Ingresado",
      dataIndex: "dataIncome",
      key: "dataIncome",
      width: 5,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    {
      title: "Calculado",
      dataIndex: "data",
      key: "data",
      width: 5,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    {
      title: "Unidades",
      dataIndex: "unit",
      key: "unit",
      width: 5,
      onHeaderCell: () => ({
        className: styles.tableHeader,
      }),
      onCell: () => ({
        className: styles.tableContent,
      }),
    },
    /*{
      title: "Creado",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 7,
      onHeaderCell: () => ({
      className: styles.tableHeader, // Aplica estilos al encabezado
    }),
    onCell: () => ({
      className: styles.tableContent, // Aplica estilos al contenido
    }),
    render: (text) => (text ? moment(text).format("YYYY-MM-DD") : "N/A"), 
    },
    {
      title: "Última actualización",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 7,
      onHeaderCell: () => ({
      className: styles.tableHeader, // Aplica estilos al encabezado
    }),
    onCell: () => ({
      className: styles.tableContent, // Aplica estilos al contenido
    }),
    render: (text) => (text ? moment(text).format("YYYY-MM-DD") : "N/A"), 
    },*/
  ];

  const newActionEvent: ColumnType<GeiEvents> = {
    title: '',
    key: 'operation',
    fixed: 'right',
    width: 20,
    onHeaderCell: () => ({
      className: styles.tableHeader,
    }),
    onCell: () => ({
      className: styles.tableContent,
    }),

    render: (record: GeiEvents) => (
      <Space size="middle">

        <Button
          type="text"
          className={className["update-button"]}
          onClick={() => showModalUpdateEvent(record)}
          icon={<EditOutlined />}
        />
        <Button
          type="text"
          className={className["danger-button"]}
          onClick={() => showModalInactiveEvent(record)}
          icon={<DeleteOutlined />}
        />
      </Space>
    ),
  };

  const newActionActivity: ColumnType<GeiEventsActivity> = {
    title: '',
    key: 'operation',
    fixed: 'right',
    width: 4.5,
    onHeaderCell: () => ({
      className: styles.tableHeader,
    }),
    onCell: () => ({
      className: styles.tableContent,
    }),

    render: (record: GeiEventsActivity) => (
      <Space size="middle">
        <Button
          type="text"
          className={className["update-button"]}
          onClick={() => showModalUpdateActivity(record)}
          icon={<EditOutlined />}
        />
        <Button
          type="text"
          className={className["danger-button"]}
          onClick={() => confirmDeleteEventActivity(record.id!)}
          icon={<DeleteOutlined />}
        />
      </Space>
    ),
  };

  const adminColumnsEvent: ColumnsType<GeiEvents> = [
    //...[columnOrganizationAdminType],
    ...[columnRUCAdminType],
    ...columnsTypeEvent,
    ...[newActionEvent],
  ];
  const clientColumnsEvent: ColumnsType<GeiEvents> = [
    ...[columnRUCAdminType],
    ...columnsTypeEvent,
    ...[newActionEvent],
  ];

  const adminColumnsActivity: ColumnsType<GeiEventsActivity> = [
    //...[columnOrganizationAdminType],
    //...[columnRUCAdminType],
    ...columnsTypeActivity,
    ...[newActionActivity],
  ];
  const clientColumnsActivity: ColumnsType<GeiEventsActivity> = [
    ...columnsTypeActivity,
    ...[newActionActivity],
  ];

  const handleCancelEvent = () => {
    setIsModalOpenEvent(false);
    setSelectedDays([]);
  };

  const handleCancelActivity = () => {
    setIsModalOpenActivity(false);
  };

  const handleCancelSchedule = () => {
    setIsModalOpenSchedule(false);
  };

  const handleCancelInactiveEvent = () => {
    setIsModalOpenInactiveEvent(false);
  };

  const onFormLayoutChange = ({ size }: { size: SizeType }) => {
    setComponentSize(size);
  };

  const showModalCreateEvent = async () => {
    setPreviousSelectedDays([...selectedDays]);

    formEvents.resetFields();

    const sorted = [...selectedDays].sort();
    setSortedDays(sorted);

    if (sorted.length > 0) {
      setIsModalOpenEvent(true);
      setTypeModalEvent(true);
    }
  };
  const showQuestionEvent = async (value: GeiEvents) => {
    window.open(`${process.env.REACT_APP_BASE_QUESTION}/${value.id}`, '_blank');

  }
  const showModalUpdateEvent = async (value: GeiEvents) => {
    try {
      const responseDataCity = await props.getAllCitiesByOrganization(value.msIdentityOrganizationId);
      //const responseDataCity = await props.getAllCitiesByOrganization('f67ce3ac-6f3f-4320-9199-55c754299725');
      setSelectGeiEvent(value);
      setCities(responseDataCity || []);
      formEvents.resetFields();
      setGeiId(value.id!);
      setType(value.msCatalogueCityId!);
      formEvents.setFieldsValue({
        name: value.name,
        theme: value.theme,
        //duration: value.duration,
        participant: value.participant,
        city: value.msCatalogueCityId,
        address: value.address,
        msIdentityTypeEventId: value.msIdentityTypeEventId,
        msIdentityTypeEventName: value.msIdentityTypeEventName,
      });

      setIsModalOpenEvent(true);
      setTypeModalEvent(false);
    } catch (error) {
      openNotification("Error", "No se pudo cargar las ciudades para la organización seleccionada.");
    }
  };

  const showModalRegisterActivity = async (scheduleId: string) => {
    try {
      const responseDataOrganizationTable = await props.getEmissionsByTypeId(selectGeiEvent?.msIdentityTypeEventId);
      setSelectDataTableEmissions(responseDataOrganizationTable);
      formActivityEvent.resetFields();
      formActivityEvent.setFieldsValue({
        scheduleId: scheduleId
        /*baseUnit: value.baseUnit;
        data: value.data;
        unit: value.unit;
        observation: value.observation | '';
        MsIdentityEmissionSourcesId: string;*/
      });

      setIsModalOpenActivity(true);
      setTypeModalActivity(true);
    } catch (error) {
      openNotification("Error", "No se pudo cargar las ciudades para la organización seleccionada.");
    }
  };

  const showModalUpdateSchedule = async (schedule: GeiEventsSchedule) => {
    try {
      formSchedule.resetFields();
      const formattedDate = schedule.date
        ? dayjs(`${schedule.date.year}-${schedule.date.month}-${schedule.date.day}`, 'YYYY-M-D')
        : null;
      const formattedInitialHour = schedule.initialHour ? dayjs(schedule.initialHour, 'HH:mm') : null;
      const formattedEndHour = schedule.endHour ? dayjs(schedule.endHour, 'HH:mm') : null;
      formSchedule.setFieldsValue({
        date: formattedDate,
        initialHour: formattedInitialHour,
        endHour: formattedEndHour,
      });
      setIsModalOpenSchedule(true);
    } catch (error) {
      openNotification("Error", "No se pudo cargar Información de la fecha");
    }
  };

  const showModalInactiveEvent = async (EventId: GeiEvents) => {
    try {
      setSelectGeiEvent(EventId);
      formInactiveEvent.resetFields();
      setIsModalOpenInactiveEvent(true);
      setTypeModalInactiveEvent(true);
    } catch (error) {
      openNotification("Error", "No se pudo cargar la vista");
    }
  };

  const showModalUpdateActivity = async (value: GeiEventsActivity) => {
    try {
      const responseDataOrganizationTable = await props.getEmissionsByTypeId(selectGeiEvent?.msIdentityTypeEventId);
      setSelectDataTableEmissions(responseDataOrganizationTable);
      setSelectedEventActivity(value);
      formActivityEvent.resetFields();
      formActivityEvent.setFieldsValue({
        MsIdentityEmissionSourcesId: value.emissionSourceId,
        baseUnit: value.baseUnit,
        data: value.dataIncome,
        unit: value.unit
      });

      setIsModalOpenActivity(true);
      setTypeModalActivity(false);
    } catch (error) {
      openNotification("Error", "No se pudo cargar las Emisiones para la organización seleccionada.");
    }
  };

  const onFinishActivity = async (values: any) => {
    if (values.code == undefined) {
      values.code = "A";
    }
    const Postregister = {
      scheduleId: selectedScheduleId,
      baseUnit: values.baseUnit,
      data: values.data,
      observation: values.observation,
      MsIdentityEmissionSourcesId: searchValue?.id
    };
    const Putregister = {
      id: selectedEventActivity?.id,
      scheduleId: selectedEventActivity?.scheduleId,
      baseUnit: values.baseUnit,
      data: values.data,
      observation: values.observation,
      MsIdentityEmissionSourcesId: searchValue?.id ? searchValue?.id : selectedEventActivity?.emissionSourceId
    };
    //handleCancelActivity();
    if (typeModalActivity) {
      await props.postGeiEventActivity(Postregister);
    }
    else {
      await props.putGeiActivityEvent(Putregister);
    }
    const responseDataActivity = await props.getGeiEventActivityByScheduleId(selectedScheduleId);
    setDataEventsActivity(responseDataActivity || []);
    const responseDataResults = await props.getGeiEventResults(selectGeiEvent?.id);
    if (JSON.stringify(dataEventsResults) !== JSON.stringify(responseDataResults)) {
      setDataEventsResult(responseDataResults);
    }
    formActivityEvent.resetFields();
    formValidateActivity.resetFields();
  };

  const onFinishEvent = async (values: any) => {
    if (values.code == undefined) {
      values.code = "A";
    }
    const formattedInitialHour = values.InitialHour ? values.InitialHour.format('HH:mm') : null;
    const formattedEndHour = values.EndHour ? values.EndHour.format('HH:mm') : null;
    const Postregister = {
      name: values.name,
      theme: values.theme,
      participant: values.participant,
      msCatalogueCityId: values.city,
      address: values.address,
      msIdentityOrganizationId: values.msIdentityOrganizationId,
      msIdentityTypeEventId: values.msIdentityTypeEventId,
      dates: sortedDays,
      InitialHour: formattedInitialHour,
      EndHour: formattedEndHour
    };
    const Putregister = {
      id: selectGeiEvent?.id,
      name: values.name,
      theme: values.theme,
      duration: values.duration,
      participant: values.participant,
      msCatalogueCityId: values.city,
      address: values.address,
      msIdentityOrganizationId: selectGeiEvent?.msIdentityOrganizationId,
      msIdentityTypeEventId: values.msIdentityTypeEventId,
    };
    handleCancelEvent();
    if (typeModalEvent) {
      await props.postRegisterGeiEvent(Postregister);
    }
    else {
      await props.putRegisterGeiEvent(Putregister);
    }
    const responseData: GeiEventsResponse = await props.getGeiEventById(pagination.current, pagination.pageSize, "");
    setDataEvents(responseData.eventsTables);
    formEvents.resetFields();
    formValidateEvent.resetFields();
  };

  const onFinishSchedule = async (values: any) => {
    const formattedInitialHour = values.initialHour ? values.initialHour.format('HH:mm') : null;
    const formattedEndHour = values.endHour ? values.endHour.format('HH:mm') : null;
    const putRegister = {
      id: selectedEventsSchedule?.id,
      date: values.date.format('YYYY-MM-DD'),
      initialHour: formattedInitialHour,
      endHour: formattedEndHour
    };
    handleCancelSchedule();
    await props.putScheduleGeiEvent(putRegister);

    const responseDataSchedules = await props.getGeiEventScheduleByEventId(selectedEventsSchedule?.eventsId);
    setDataEventsSchedule(responseDataSchedules || []);
    formSchedule.resetFields();
    formValidateSchedule.resetFields();
  };

  const onFinishInactiveEvent = async (values: any) => {
    const putRegister = {
      id: selectGeiEvent?.id,
      observation: values.observation,
    };
    handleCancelInactiveEvent();

    await props.putActivoGeiEvent(putRegister);
    const responseData: GeiEventsResponse = await props.getGeiEventById(pagination.current, pagination.pageSize, "");
    setDataEvents(responseData.eventsTables);

    formSchedule.resetFields();
    formValidateSchedule.resetFields();
  };

  const confirmDeleteEventActivity = (idEventActivity: string) => {
    Modal.confirm({
      title: '¿Estás seguro de eliminar esta actividad?',
      content: 'Esta acción no se puede deshacer.',
      okText: 'Sí, eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: async () => {
        await deleteEventActivityById(idEventActivity);
      },
    });
  };

  const deleteEventActivityById = async (idEventActivity: string) => {
    await props.deleteGeiEventActivityById(idEventActivity);
    const responseDataActivity = await props.getGeiEventActivityByScheduleId(selectedScheduleId);
    setDataEventsActivity(responseDataActivity || []);
    const responseDataResults = await props.getGeiEventResults(selectGeiEvent?.id);
    if (JSON.stringify(dataEventsResults) !== JSON.stringify(responseDataResults)) {
      setDataEventsResult(responseDataResults);
    }
  }


  const daysOfWeek = ["D", "L", "M", "M", "J", "V", "S"];
  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const getDaysInMonth = (year: number, month: number) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const formatDate = (year: number, month: number, day: number): string => {
    const formattedMonth = (month + 1).toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  };

  const generateCalendar = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = getDaysInMonth(year, month);

    const calendarDays = [];
    for (let i = 0; i < firstDay; i++) {
      calendarDays.push(null);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      calendarDays.push(day);
    }

    return calendarDays;
  };

  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
    setSelectedDays([]);
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
    setSelectedDays([]);
  };

  const handleDayMouseDown = (day: number) => {
    setIsSelecting(true);
    setStartDay(day);
    setSelectedDays([formatDate(currentDate.getFullYear(), currentDate.getMonth(), day)]);
  };

  const handleDayMouseEnter = (day: number) => {
    if (isSelecting && startDay !== null) {
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();
      const range = [];

      const start = Math.min(startDay, day);
      const end = Math.max(startDay, day);

      for (let i = start; i <= end; i++) {
        range.push(formatDate(year, month, i));
      }

      setSelectedDays(range);
    }
  };

  const handleMouseUp = () => {
    if (
      isSelecting &&
      selectedDays.length > 0 &&
      JSON.stringify(selectedDays) !== JSON.stringify(previousSelectedDays)
    ) {
      setPreviousSelectedDays([...selectedDays]);
      formEvents.resetFields();
      const sortedDays = [...selectedDays].sort();

      formEvents.setFieldsValue({
        InitialDate: sortedDays[0],
        EndDate: sortedDays[sortedDays.length - 1],
      });

      setIsModalOpenEvent(true);
      setTypeModalEvent(true);
    }
    setIsSelecting(false);
  };

  const handleDayClick = (day: number) => {
    const selectedDate = formatDate(currentDate.getFullYear(), currentDate.getMonth(), day);

    // Verifica si el día ya está seleccionado
    setSelectedDays((prevSelectedDays) => {
      if (prevSelectedDays.includes(selectedDate)) {
        // Si ya está seleccionado, lo eliminamos (deselección)
        return prevSelectedDays.filter(date => date !== selectedDate);
      } else {
        // Si no está seleccionado, lo agregamos
        return [...prevSelectedDays, selectedDate];
      }
    });
  };


  const handleNewActivityClick = (scheduleId: string | undefined) => {
    if (!scheduleId) {
      console.warn("Debe seleccionar una fecha antes de crear una actividad.");
      return;
    }
    setshowFlow(false);

    showModalRegisterActivity(scheduleId);
  };

  const handlePutScheduleClick = (scheduleId: string | undefined) => {
    if (!scheduleId) {
      console.warn("Debe seleccionar una fecha antes de crear una actividad.");
      return;
    }
    showModalUpdateSchedule(selectedEventsSchedule!);
  };

  const openLink = () => {
    const url = process.env.REACT_APP_BASE_URL as string + '/powerbi/' + selectGeiEvent?.msIdentityOrganizationId + "/EVENTOS_GEI";
    window.open(url, '_blank');
    // if (isUrlLinkButtom) {
    //   window.open(isUrlLinkButtom, '_blank');
    // }
  };


  const handleSelectChangeEmission = async (type: EmissionsSource) => {
    setSearchValue(type);
    const responseDataBaseUnit = await props.getTransformationFactorsUnitByEmissionorganizationId(selectGeiEvent?.msIdentityOrganizationId, type);
    setDataBaseUnit(responseDataBaseUnit);
  };


  const calendarDays = generateCalendar();
  const uniqueGroups = Array.from(
    new Set(selectDataTableEmissions.map((item) => item.group))
  );

  const [showFlow, setshowFlow] = useState(false);

  const [selectedGroup, setSelectedGroup] = useState<string | null>(null);

  const filteredEmissions = selectedGroup
    ? selectDataTableEmissions.filter((item) => item.group === selectedGroup)
    : [];
  return (
    <>
      <div className="empresa-chubb">
        <div>
          <div className={styles.container} onMouseUp={handleMouseUp}>
            {/* Contenedor del calendario */}
            <div className={styles.calendar}>
              <header className={styles.calendarHeader}>
                <button onClick={handlePrevMonth} className={styles.navButton}>
                  {"<"}
                </button>
                <h2 className={styles.monthTitle}>
                  {months[currentDate.getMonth()]} {currentDate.getFullYear()}
                </h2>
                <button onClick={handleNextMonth} className={styles.navButton}>
                  {">"}
                </button>
              </header>
              <div className={styles.calendarGrid}>
                {daysOfWeek.map((day, index) => (
                  <div key={index} className={styles.dayHeader}>
                    {day}
                  </div>
                ))}
                {calendarDays.map((day, index) =>
                  day ? (
                    <div
                      key={index}
                      onClick={() => handleDayClick(day)}
                      className={styles.calendarDay}
                      style={{
                        backgroundColor: selectedDays.includes(formatDate(currentDate.getFullYear(), currentDate.getMonth(), day))
                          ? "#01C1D6"
                          : day === today.getDate() &&
                            currentDate.getMonth() === today.getMonth() &&
                            currentDate.getFullYear() === today.getFullYear()
                            ? "#AFAFAF"
                            : "transparent",
                        color: selectedDays.includes(formatDate(currentDate.getFullYear(), currentDate.getMonth(), day))
                          ? "white"
                          : "black",
                      }}
                    >
                      {day}
                    </div>


                  ) : (
                    <div key={index}></div>
                  )
                )}

              </div>
              <div className={styles.newEventPadding}>
                <Button className={styles.newEventButton} onClick={() => showModalCreateEvent()}>Crear Evento</Button>
              </div>

            </div>
            {/* Contenedor de la tabla de Eventos */}
            <div className={styles.tableContainerEvent}>
              <Table size="small" columns={props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190" ? adminColumnsEvent : clientColumnsEvent} dataSource={dataEvents} scroll={{ x: 600, y: 450 }} pagination={pagination}
                onChange={handleTableChange} />
            </div>
          </div>
          {/*SEGUNDA FILA ACTIVIDAD Y RESULTADOS*/}
          <div className={styles.titleContainer}>
            <h3 className={styles.activityTitle}>Data de Actividad del Evento: "{selectGeiEvent?.name}"</h3>
            <Select
              showSearch
              className={styles.selectDropdown}
              onChange={async (selectedId: string) => {
                console.log(`Has seleccionado la fecha con ID: ${selectedId}`);
                setSelectedScheduleId(selectedId);

                const selectedSchedule = dataEventsSchedule.find((schedule) => schedule.id === selectedId);
                if (selectedSchedule) {
                  setSelectedEventsSchedule(selectedSchedule);
                  setSelectedScheduleDate(formatSelectedDate(selectedSchedule));
                }

                try {
                  const responseDataActivity = await props.getGeiEventActivityByScheduleId(selectedId);
                  setDataEventsActivity(responseDataActivity || []);
                } catch (error) {
                  console.error("Error al obtener actividades:", error);
                }
              }}
              value={selectedScheduleId}
              placeholder="Seleccione una fecha de evento"
            >
              {dataEventsSchedule.map((schedule: GeiEventsSchedule) => (
                <Option key={schedule.id} value={schedule.id}>
                  {formatSelectedDate(schedule)}
                </Option>
              ))}
            </Select>
            <Button
              className={styles.newActivityButton}
              onClick={() => handleNewActivityClick(selectedScheduleId)}
            >
              Registrar actividad del {selectedScheduleDate || "Seleccione fecha"}
            </Button>
            <Button
              className={styles.uodateScheduleButton}
              onClick={() => handlePutScheduleClick(selectedScheduleId)}
            >
              Actualizar {selectedScheduleDate || "Seleccione fecha"}
            </Button>
            {isShowButtomLink &&
              <Button
                className={styles.uodateScheduleButton}
                onClick={() => openLink()}
              >
                Visualizar Resultados en Power BI
              </Button>

            }

          </div>
          <div className={styles.container} onMouseUp={handleMouseUp}>
            {/* Contenedor de la tabla de EventActivity */}
            <div className={styles.tableContainer}>
              <Table size="small" columns={adminColumnsActivity} dataSource={dataEventsActivity} scroll={{ x: 700, y: 350 }} pagination={{ pageSize: 5 }} />
            </div>
            {/* Tabla de resultados */}
            <div className={styles.ContainerResults}>
              {dataEventsResults ? (
                <div>
                  <div className={styles.containerTotals} onMouseUp={handleMouseUp}>
                    <div>
                      <h2 className={styles.totalEmissionsTitle}>Total de emisión</h2>
                      <span className={styles.totalEmissionsValue}>{dataEventsResults.totalEmissiontco2} t-CO₂</span>
                    </div>
                    <div>
                      <h2 className={styles.totalEmissionsTitle}>Total por participante</h2>
                      <span className={styles.totalEmissionsValue}>{dataEventsResults.totalEmissionParticipantstco2} t-CO₂</span>
                    </div>
                  </div>
                  {(() => {
                    return (
                      <>
                        <div className={styles.ContainerResults}>
                          <div className={styles.chartContainer}>
                            <DoughnutChart data={{ labels: chartData.labels, values: chartData.values, colors: chartColors }} />

                          </div>
                          <div className={styles.listContainerWrapper}>
                            <EventList events={dataEventsResults.individualEventResultsResponses} colors={chartColors} />
                          </div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              ) : (
                <p>Haz Click sobre un evento para mostrar resultados</p>
              )}
            </div>


          </div>
        </div>
        {/*MODAL DE EVENTO*/}
        <Drawer
          title={<span className={styles.title}>{typeModalEvent ? "Nuevo Evento" : "Actualizar Evento"}</span>}
          open={isModalOpenEvent}
          onClose={handleCancelEvent}
          width={750}
          footer={null}
          placement={'right'}
        >
            <Form form={formEvents}
              layout="vertical"
              initialValues={{ requiredMarkValue: requiredMark }}
              requiredMark={requiredMark}
              onFinish={onFinishEvent}
              onValuesChange={onFormLayoutChange}
              size={componentSize as SizeType}
              className="drawerFontFix"
            >
              {/* Campos que solo se muestran en modo "Crear" */}
              {typeModalEvent && (
                <>
                  <Form.Item
                    name="InitialHour"
                    label="Hora de inicio"
                    rules={[{ required: true, message: validateMessages.emptyField }]}
                    style={{ fontFamily: "var(--font-main)" }}
                  >
                    <TimePicker
                      format="HH:mm"
                      minuteStep={30}
                      style={{ width: "100%", fontFamily: "var(--font-main)" }}
                      placeholder="Selecciona hora"
                    />
                  </Form.Item>
                  <Form.Item
                    name="EndHour"
                    label="Hora de culminación"
                    rules={[{ required: true, message: validateMessages.emptyField }]}
                    style={{ fontFamily: "var(--font-main)" }}
                  >
                    <TimePicker
                      format="HH:mm"
                      minuteStep={30}
                      style={{ width: "100%", fontFamily: "var(--font-main)"}}
                      placeholder="Selecciona hora"
                    />
                  </Form.Item>
                  <Form.Item
                    label="Organización"
                    name="msIdentityOrganizationId"
                    rules={[{ required: true, message: validateMessages.emptyField }]}
                    style={{ fontFamily: "var(--font-main)" }}
                  >
                    <Select
                      showSearch
                      style={{ width: "100%", fontFamily: "var(--font-main)" }}
                      onChange={async (selectedId: string, option: any) => {
                        setTypeOrganization(selectedId);
                        const responseData = await props.getAllCitiesByOrganization(selectedId);
                        setCities(responseData);
                      }}
                      filterOption={(input, option) =>
                        option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      value={typeOrganization}
                      placeholder="Escoga la organización"
                    >
                      {organization.map((org: Organization) => (
                        <Option key={org.id} value={org.id}>
                          {`${org.ruc} - ${org.name}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                </>
              )}
              <Form.Item name="name" label="Evento" rules={[{ required: true, message: validateMessages.emptyField }]} style={{ fontFamily: "var(--font-main)" }}>
                <Input placeholder="Un nombre para el evento" />
              </Form.Item>
              <Form.Item
                label="Tipo"
                name="msIdentityTypeEventId"
                rules={[{ required: true, message: validateMessages.emptyField }]}
                style={{ fontFamily: "var(--font-main)" }}
              >
                <Select
                  showSearch
                  className={`${styles["select-modality"]}`}
                  onChange={async (selectedId: string, option: any) => {
                    setTypeEvent(selectedId);
                  }}
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  value={typeEvent}
                  placeholder="Escoga el tipo de evento"
                >
                  {typeEvents.map((tev: GeiTypeEvents) => (
                    <Option key={tev.id} value={tev.id}>
                      {`${tev.name}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="theme"
                label={<span style={{ fontFamily: "var(--font-main)" }}>Tema</span>}
                rules={[{ required: true, message: validateMessages.emptyField }]}
                style={{ fontFamily: "var(--font-main)" }}
              >
                <Input placeholder="Un tema para el evento" style={{ fontFamily: "var(--font-main)" }} />
              </Form.Item>
              {/*!typeModalEvent && (
            <>
              <Form.Item name="duration" label="Duración" rules={[{ required: true, message: validateMessages.emptyField }]}>
                <Input placeholder="Tiempo de duración" />
              </Form.Item>
            </>
          )*/}
              <Form.Item name="participant" label="Participantes" rules={[{ required: true, message: validateMessages.emptyField }]} style={{ fontFamily: "var(--font-main)" }}>
                <Input placeholder="Número de personas que asisten" />
              </Form.Item>
              <Form.Item label="Ciudad" name="city" rules={[{ required: true, message: validateMessages.emptyField }]} style={{ fontFamily: "var(--font-main)" }}>
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  onChange={(value: string) => setType(value)}
                  filterOption={(input, option) => {
                    const optionText = (option?.label as string)?.toLowerCase() || "";
                    return optionText.includes(input.toLowerCase());
                  }}
                  value={type}
                  placeholder="Selecciona la ciudad"
                  options={cities.map((city: Cities) => ({
                    label: city.name,
                    value: city.id,
                  }))}
                />
              </Form.Item>
              <Form.Item name="address" label="Dirección" rules={[{ required: true, message: validateMessages.emptyField }]} style={{ fontFamily: "var(--font-main)" }}>
                <Input placeholder="Dirección del sitio" />
              </Form.Item>
              <Form.Item>
                <Button className={className["user-button"]} type="primary" htmlType="submit" style={{ fontFamily: "var(--font-main)" }}>
                  {typeModalEvent ? "Agregar" : "Actualizar"}
                </Button>
              </Form.Item>
            </Form>
        </Drawer>
        {/*MODAL DE ACTIVIDAD*/}
        <Modal
          title={<span className={styles.title}>{typeModalActivity ? "Nueva Actividad del " + selectedScheduleDate : "Actualizar Actividad"}</span>}
          open={isModalOpenActivity}
          onCancel={handleCancelActivity}
          width={1000}
          footer={null}
          className={styles.modalContentStyle} // Aplicar el estilo al Modal
        >

          {!showFlow ? <div className={className["card-container"]}>
            <Row justify="start" >
              {uniqueGroups.map((group, index) => (
                <Col xxl={8} xl={4} lg={4} md={4} sm={24} xs={24}>
                  <div className={className["card"]} onClick={() => {
                    setSelectedGroup(group);  // guardas el grupo
                    setshowFlow(true);        // muestras el formulario
                  }}>
                    <p className="text-gray-600">{group}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div> :

            <Form form={formActivityEvent}
              layout="vertical"
              initialValues={{ requiredMarkValue: requiredMark }}
              requiredMark={requiredMark}
              onFinish={onFinishActivity}
              onValuesChange={onFormLayoutChange}
              size={componentSize as SizeType}
            >

              <Form.Item
                label="Fuente de emisión"
                name="MsIdentityEmissionSourcesId"
                rules={[{ required: true, message: validateMessages.emptyField }]}
              >
                <Select
                  size='large'
                  showSearch
                  style={{ width: "100%" }}
                  onChange={async (selectedId: string, option: any) => {
                    setTypeActivity(selectedId);
                    const datValue: EmissionsSource | undefined = selectDataTableEmissions.find(
                      (emission) => emission.id === selectedId
                    );
                    setSearchValue(datValue);
                    const responseDataBaseUnit =
                      await props.getTransformationFactorsUnitByEmissionSourceId(datValue?.id);
                    setDataBaseUnit(responseDataBaseUnit);
                  }}
                  filterOption={(input: any, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Escoga la fuente de emisión"
                >
                  {filteredEmissions.map((type: EmissionsSource) => (
                    <Option key={`type-option-${type.id}`} value={type.id}>
                      {type.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label="Unidad base" name="baseUnit" rules={[{ required: true, message: validateMessages.emptyField }]}>
                <Select
                  size='large'
                  showSearch
                  style={{ width: "100%" }}
                  filterOption={(input: any, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }

                  value={searchValue}
                  placeholder="Escoga la unidad base"
                >
                  {dataBaseUnit.map((type: string) => (
                    <Option key={`type-option-${type}`} value={type}
                    >
                      {type}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="data"
                label="Dato"
                rules={[{ required: true, message: validateMessages.emptyField }]}
              >
                <Input size='large' placeholder="Ingresar dato" />
              </Form.Item>
              <Form.Item>
                <Button className={className["user-button"]} type="primary" htmlType="submit">
                  {typeModalActivity ? "Agregar" : "Actualizar"}
                </Button>
              </Form.Item>
              <Button className={className["user-button"]} type="primary" onClick={() => {
                setshowFlow(false);
                setSelectedGroup(null);
                formActivityEvent.resetFields()
              }} >
                {"Regresar"}
              </Button>
            </Form>
          }
          <LoadingIndicator />

        </Modal>
        {/*MODAL DE FECHAS*/}
        <Modal
          title={<span className={styles.title}>Actualizar Fecha</span>}
          open={isModalOpenSchedule}
          onCancel={handleCancelSchedule}
          width={350}
          footer={null}
          className={styles.modalContentStyle} // Aplicar el estilo al Modal
        >
          <Form form={formSchedule}
            layout="vertical"
            initialValues={{ requiredMarkValue: requiredMark }}
            requiredMark={requiredMark}
            onFinish={onFinishSchedule}
            onValuesChange={onFormLayoutChange}
            size={componentSize as SizeType}>
            <Form.Item
              name="date"
              label="Fecha"
              rules={[{ required: true, message: "Por favor selecciona una fecha" }]}
            >
              <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} placeholder="Selecciona fecha" />
            </Form.Item>
            <Form.Item
              name="initialHour"
              label="Hora de inicio"
              rules={[{ required: true, message: validateMessages.emptyField }]}
            >
              <TimePicker
                format="HH:mm"
                minuteStep={30}
                style={{ width: "100%" }}
                placeholder="Selecciona hora"
              />
            </Form.Item>
            <Form.Item
              name="endHour"
              label="Hora de culminación"
              rules={[{ required: true, message: validateMessages.emptyField }]}
            >
              <TimePicker
                format="HH:mm"
                minuteStep={30}
                style={{ width: "100%" }}
                placeholder="Selecciona hora"
              />
            </Form.Item>
            <Form.Item>
              <Button className={className["user-button"]} type="primary" htmlType="submit">
                {"Actualizar"}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        {/*MODAL DE INACTIVAR EVENTO*/}
        <Modal
          title={<span className={styles.title}>Inhabilitar Evento</span>}
          open={isModalOpenInactiveEvent}
          onCancel={handleCancelInactiveEvent}
          width={350}
          footer={null}
          className={styles.modalContentStyle} // Aplicar el estilo al Modal
        >
          <Form form={formInactiveEvent}
            layout="vertical"
            initialValues={{ requiredMarkValue: requiredMark }}
            requiredMark={requiredMark}
            onFinish={onFinishInactiveEvent}
            onValuesChange={onFormLayoutChange}
            size={componentSize as SizeType}
          >
            {/* Campos que solo se muestran en modo "Crear" */}
            {typeModalEvent && (
              <>
                <Form.Item
                  name="observation"
                  label="Motivo"
                  rules={[{ required: true, message: "Por favor ingrese un motivo para Inactivar" }]}
                >
                  <Input placeholder="Motivo para inactivar" />
                </Form.Item>
                <Form.Item>
                  <Button className={className["danger-button"]} type="primary" htmlType="submit">
                    {"Inactivar"}
                  </Button>
                </Form.Item>
              </>
            )}
          </Form>
        </Modal>
      </div>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  user: state.user
});
export default connect(mapStateToProps,
  {
    postRegisterGeiEvent,
    putRegisterGeiEvent,
    putActivoGeiEvent,
    putRegisterStatusGeiEvent,
    getGeiEventById,
    getUserByToken,
    getAllCitiesByOrganization,
    getAllOrganization,
    getTypeEvent,
    getGeiEventScheduleByEventId,
    getGeiEventActivityByScheduleId,
    getTransformationFactorsUnitByEmissionorganizationId,
    getTransformationFactorsUnitByEmissionId,
    getTransformationFactorsUnitByEmissionSourceId,
    getEmissionsOrganization,
    postGeiEventActivity,
    getGeiEventResults,
    deleteGeiEventActivityById,
    getEmissionsByTypeId,
    putScheduleGeiEvent,
    putGeiActivityEvent,
    getLinkByorganizationIdAndService
  })(TGeiEvents);